<template lang="pug">
  #js-local-name.modal.fade
    .modal-dialog.modal-dialog-centered
      .modal-content
        .modal-header
          h5.modal-title
            | ユーザー情報
        .modal-body
          .form-group.mb-0
            label(for="localName")
              | ユーザー名
            input#localName.form-control(
              type="text",
              v-model="localName"
            )
        .modal-footer
          button.btn.btn-primary(
            type="button",
            data-dismiss="modal",
            :disabled="!localName"
          )
            | 会議に参加
</template>

<script>
import $ from 'jquery'

export default {
  name: 'localName',
  data () {
    return {
      localName: ''
    }
  },
  computed: {
    room () {
      return this.$store.state.room
    }
  },
  watch: {
    localName () {
      // モーダルが表示されていれば
      if ($('#js-local-name').data('bs.modal')) {
        this.backdrop()
      }
    },
    room () {
      // 最初の１回のみ発火するように
      if (this.$store.getters.localUser || this.$store.state.stealth) return

      // roomを取得したあとに実行
      this.room.on('open', () => {
        this.roomMounted()
      })
    }
  },
  methods: {
    roomMounted () {
      this.localName = localStorage.getItem('goqmeLocalName') || ''

      // モーダルが開かれる時
      $('#js-local-name').on('show.bs.modal', this.backdrop)

      // モダールが閉じられる時
      $('#js-local-name').on('hidden.bs.modal', this.updateUserNames)

      // ユーザー名が未保存なら、初期値をゲストにしてモーダルを起動
      if (!this.localName) {
        this.localName = 'ゲスト'
        $('#js-local-name').modal('show')
        return
      }

      // ユーザー名があれば、モーダルを起動せず、そのまま参加
      this.updateUserNames()
    },
    backdrop () {
      // モーダル周り背景クリック時に、モーダルを消せるかどうか
      if (this.localName) {
        $('#js-local-name').data('bs.modal')._config.backdrop = 'true'
        return
      }

      $('#js-local-name').data('bs.modal')._config.backdrop = 'static'
    },
    updateUserNames () {
      const payload = {
        type: 'users',
        peerId: this.$store.state.peerId,
        data: {
          name: this.localName,
          cameraFlag: true,
          micFlag: true,
          icon: localStorage.getItem('goqmeLocalIcon')
        }
      }

      this.room.send(payload)
      this.$store.dispatch('updateUsers', { payload })
      localStorage.setItem('goqmeLocalName', this.localName)
    }
  }
}
</script>
